/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DeliveryInputDto { 
    cdStore?: number;
    dsName: string;
    dsPhone: string;
    dsPassword: string;
    isActive: boolean;
    dtLicenseExpiration: Date;
    dtCirculationExpiration: Date;
    dsLicense: string;
    dsCirculation: string;
    dsPatent: string;
    qtCommission: number;
}